import http from "src/_services/httpService";

import { $BASE_URL } from "src/constants";

const apiEndpoint =  `${$BASE_URL}/api/v1/zone`;

function zoneUrl(id) {
    return `${apiEndpoint}/${id}`;
}

const createZone = (zone) => {
    return http.post(apiEndpoint, zone);
}

const getZones = _ => {
    return http.get(apiEndpoint);
}

const getZone = (zoneId) => {
    return http.get(zoneUrl(zoneId));
}

const updateZone = (zoneId, zone) => {
    return http.put(zoneUrl(zoneId), zone);
}

const deleteZone = (zoneId) => {
    return http.delete(zoneUrl(zoneId));
}

const ZoneService = {
    createZone,
    getZones,
    getZone,
    updateZone,
    deleteZone
};

export default ZoneService;